// styles
// import "ng-formio/dist/formio.css";
// import "webforms/formio/formio.scss";
import "formiojs/dist/formio.builder.css";
import "webforms/formio/formio.client.scss";
import "webforms/formio/formio-fixes.scss";

//dependencies
import formio_bs3 from "@formio/bootstrap3";
import { Formio } from "formiojs";

Formio.use(formio_bs3);
Formio.icons = "fontawesome";
import "ng-formio/lib/modules";
import uiRouter from "angular-ui-router";

//modules

//services
// replace: \.(component|directive)\("(\w+)",\s*(\w+)\) with: $2,
//states

import states from "webforms/formio/formio.states";

//components
import formioBrowser from "webforms/formio/formio-browser";
import formioContainer from "webforms/formio/formio-container";
import formioSubmissions from "webforms/formio/formio-submissions";
import formSubmission from "webforms/formio/form-submission";
import formSubmissions from "webforms/formio/form-submissions";
import formioDetails from "webforms/formio/formio-details";

//directives
import formioList from "webforms/formio/formio-list";
import formioSubmissionPrompt from "webforms/formio/formio-submission-prompt.directive";

export const dependencies = ["formio", uiRouter];

export const modules = {
  // modals,
};

export const services = {};

export const components = {
  formioBrowser,
  formioContainer,
  formioDetails,
  formioSubmissions,
  formioSubmission: formSubmission,
  formSubmission,
  formSubmissions,
};

export const directives = {
  formioList,
  formSubmissionPrompt: formioSubmissionPrompt,
  formioSubmissionPrompt,
};

export default {
  modules,
  states,
  services,
  dependencies,
  components,
  directives,
};
